// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoriesColumn_wrapper__uxVC9","header":"CategoriesColumn_header__T+PIj"};